import { createSlice } from '@reduxjs/toolkit';
import i18n from '../../i18n';

const normalizeLanguage = (lang) => {
  if (lang?.startsWith('en')) return 'en';
  if (lang?.startsWith('tr')) return 'tr';
  return 'tr';
};

const languageSlice = createSlice({
  name: 'language',
  initialState: { lang: normalizeLanguage(localStorage.getItem('i18nextLng')) },
  reducers: {
    changeLanguage: (state, action) => {
      const normalizedLang = normalizeLanguage(action.payload);

      state.lang = normalizedLang;
      i18n.changeLanguage(normalizedLang);
      localStorage.setItem('i18nextLng', normalizedLang);
    },
  },
});

export const { changeLanguage } = languageSlice.actions;
export default languageSlice.reducer;
